document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("formLoginSoci");
  if (!form) return;
  const overlay = document.getElementById("loaderOverlay");
  const btn = form.querySelector(".btn-submit-soci");
  //const taxCodeInput = document.getElementById("taxCode");

  form.addEventListener("submit", function () {
    /*if (taxCodeInput) {
      const taxCode = taxCodeInput.value.trim();
      // aggiunge taxCode come parametro alla URL del form in base64
      if (taxCode) {
        const taxCodeBase64 = btoa(taxCode);
        form.action =
          form.action.split("?")[0] +
          "?id=" +
          encodeURIComponent(taxCodeBase64);
      }
    }*/
    // disabilita bottone
    btn.disabled = true;
    // mostra overlay
    overlay.classList.remove("d-none");
  });
});
